<ng-container *ngIf="isAcmic; else maNavbar">
  <div class="billing-navs dashboard-nav" [ngClass]="{'no-coverage':!(policyType === 'AUTO' && policyId?.length === 10 && showCompany === 'ma')}">
    <nav class="billing-details-nav">
      <!-- <a routerLinkActive="active" class="billing-nav-tab overview dashboard-nav-billing-padding"
        routerLink="/my-insurance/{{ policyId }}/billing" title="{{ 'BILLING' | translate }}">{{ "BILLING" | translate }}</a> -->
      <a class="billing-nav-tab" routerLinkActive="active" routerLink="/my-insurance/{{ policyId }}/details"
        title="{{ 'POLICY_OVERVIEW' | translate }}">{{ "POLICY_OVERVIEW" | translate }}</a>
      <a class="billing-nav-tab document" routerLinkActive="active" routerLink="/my-insurance/{{ policyId }}/coverages" *ngIf="policyType === 'AUTO' && policyId?.length === 10 && showCompany === 'ma'"
        title="{{ 'Coverages' | translate }}">{{ "Coverages" | translate }}</a>
      <a class="billing-nav-tab document" routerLinkActive="active" routerLink="/my-insurance/{{ policyId }}/documents"
        title="{{ 'DOCUMENTS' | translate }}">{{ "DOCUMENTS" | translate }}</a>
    </nav>
    <div class="empty-nav-div"></div>
  </div>
</ng-container>
<ng-template #maNavbar>
  <nav class="policy-details-nav row no-margins-hug hug-header">
    <div class="w-100 tab-navigation">
      <ul class="w-100 pl-0 d-table no-margin-bottom">
        <!-- <li routerLinkActive="active" class="width nav-underline" [ngClass]="policyType === 'AUTO' ? 'w-25' : 'w-33'">
          <a routerLink="/my-insurance/{{ policyId }}/billing" title="{{ 'BILLING' | translate }}">{{ "BILLING" |
            translate }}</a>
        </li> -->
        <li routerLinkActive="active" class="width nav-underline" [ngClass]="policyType === 'AUTO' ? 'w-25' : 'w-33'">

          <a routerLink="/my-insurance/{{ policyId }}/details" title="{{ 'POLICY_OVERVIEW' | translate }}">{{
            "POLICY_OVERVIEW" | translate }}</a>
        </li>
        <li routerLinkActive="active" class="width w-25 nav-underline"
          *ngIf="policyType === 'AUTO' && policyId?.length === 10 && showCompany === 'ma'">
          <a routerLink="/my-insurance/{{ policyId }}/coverages" title="{{ 'Coverages' | translate }}">{{ "Coverages" |
            translate }}</a>
        </li>
        <li routerLinkActive="active" class="width nav-underline" [ngClass]="policyType === 'AUTO' ? 'w-25' : 'w-33'">
          <a routerLink="/my-insurance/{{ policyId }}/documents" title="{{ 'DOCUMENTS' | translate }}">{{ "DOCUMENTS" |
            translate }}</a>
        </li>
      </ul>
    </div>
  </nav>
</ng-template>